"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: lifecycle/v2/lifecycle-service-v2.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flifecycle%2Fv2%2Flifecycle-service-v2.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleServiceV2Client = exports.RecordMilestoneReachedResponse = exports.RecordMilestoneReachedRequest = exports.AckCtaV2Response = exports.AckCtaV2Request = exports.UpdateOnboardingCustomerTypeResponse = exports.UpdateOnboardingCustomerTypeRequest = exports.UpdateCtaStatusResponse = exports.UpdateCtaStatusRequest = exports.GetCtasResponse = exports.GetCtasRequest = exports.GetAccountProgressionsResponse = exports.GetAccountProgressionsRequest = exports.Progression = exports.GetProgressResponse = exports.GetProgressRequest = exports.ProgressionMetadata = exports.ProgressContext = exports.NavigationContext = exports.FullModalContext = exports.HalfModalContext = exports.HelperCardContext = exports.AccountProgressContext = exports.Cta = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../../common/amount");
const lifecycle_customer_1 = require("../lifecycle-customer");
const lifecycle_milestone_1 = require("../lifecycle-milestone");
const lifecycle_enum_v2_1 = require("./lifecycle-enum-v2");
const protobufPackage = 'com.step.lifecycle.v2.proto';
function createBaseCta() {
    return {
        id: '',
        deepLink: '',
        title: '',
        content: '',
        accountProgressContext: undefined,
        fullModalContext: undefined,
        helperCardContext: undefined,
        halfModalContext: undefined,
        navigationContext: undefined,
        action: '',
        imageUrl: '',
    };
}
exports.Cta = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            deepLink: isSet(object.deepLink) ? globalThis.String(object.deepLink) : '',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            content: isSet(object.content) ? globalThis.String(object.content) : '',
            action: isSet(object.action) ? globalThis.String(object.action) : '',
        };
        if (isSet(object.accountProgressContext)) {
            message.accountProgressContext = exports.AccountProgressContext.fromJSON(object.accountProgressContext);
        }
        if (isSet(object.fullModalContext)) {
            message.fullModalContext = exports.FullModalContext.fromJSON(object.fullModalContext);
        }
        if (isSet(object.helperCardContext)) {
            message.helperCardContext = exports.HelperCardContext.fromJSON(object.helperCardContext);
        }
        if (isSet(object.halfModalContext)) {
            message.halfModalContext = exports.HalfModalContext.fromJSON(object.halfModalContext);
        }
        if (isSet(object.navigationContext)) {
            message.navigationContext = exports.NavigationContext.fromJSON(object.navigationContext);
        }
        if (isSet(object.imageUrl)) {
            message.imageUrl = globalThis.String(object.imageUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.deepLink !== '') {
            obj.deepLink = message.deepLink;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.content !== '') {
            obj.content = message.content;
        }
        if (message.accountProgressContext !== undefined) {
            obj.accountProgressContext = exports.AccountProgressContext.toJSON(message.accountProgressContext);
        }
        if (message.fullModalContext !== undefined) {
            obj.fullModalContext = exports.FullModalContext.toJSON(message.fullModalContext);
        }
        if (message.helperCardContext !== undefined) {
            obj.helperCardContext = exports.HelperCardContext.toJSON(message.helperCardContext);
        }
        if (message.halfModalContext !== undefined) {
            obj.halfModalContext = exports.HalfModalContext.toJSON(message.halfModalContext);
        }
        if (message.navigationContext !== undefined) {
            obj.navigationContext = exports.NavigationContext.toJSON(message.navigationContext);
        }
        if (message.action !== '') {
            obj.action = message.action;
        }
        if (message.imageUrl !== undefined && message.imageUrl !== '') {
            obj.imageUrl = message.imageUrl;
        }
        return obj;
    },
    create(base) {
        return exports.Cta.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCta();
        message.id = object.id ?? '';
        message.deepLink = object.deepLink ?? '';
        message.title = object.title ?? '';
        message.content = object.content ?? '';
        message.accountProgressContext =
            (object.accountProgressContext !== undefined && object.accountProgressContext !== null)
                ? exports.AccountProgressContext.fromPartial(object.accountProgressContext)
                : undefined;
        message.fullModalContext =
            (object.fullModalContext !== undefined && object.fullModalContext !== null)
                ? exports.FullModalContext.fromPartial(object.fullModalContext)
                : undefined;
        message.helperCardContext =
            (object.helperCardContext !== undefined && object.helperCardContext !== null)
                ? exports.HelperCardContext.fromPartial(object.helperCardContext)
                : undefined;
        message.halfModalContext =
            (object.halfModalContext !== undefined && object.halfModalContext !== null)
                ? exports.HalfModalContext.fromPartial(object.halfModalContext)
                : undefined;
        message.navigationContext =
            (object.navigationContext !== undefined && object.navigationContext !== null)
                ? exports.NavigationContext.fromPartial(object.navigationContext)
                : undefined;
        message.action = object.action ?? '';
        message.imageUrl = object.imageUrl ?? '';
        return message;
    },
};
function createBaseAccountProgressContext() {
    return { status: lifecycle_enum_v2_1.Status.INVALID_STATUS, critical: false, enabled: false };
}
exports.AccountProgressContext = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status) ? (0, lifecycle_enum_v2_1.statusFromJSON)(object.status) : lifecycle_enum_v2_1.Status.INVALID_STATUS,
            critical: isSet(object.critical) ? globalThis.Boolean(object.critical) : false,
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== lifecycle_enum_v2_1.Status.INVALID_STATUS) {
            obj.status = (0, lifecycle_enum_v2_1.statusToJSON)(message.status);
        }
        if (message.critical !== false) {
            obj.critical = message.critical;
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create(base) {
        return exports.AccountProgressContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountProgressContext();
        message.status = object.status ?? lifecycle_enum_v2_1.Status.INVALID_STATUS;
        message.critical = object.critical ?? false;
        message.enabled = object.enabled ?? false;
        return message;
    },
};
function createBaseHelperCardContext() {
    return {
        displayLocation: [],
        accountId: '',
        dismissible: false,
        ageInDays: 0,
        enabled: false,
        priority: lifecycle_enum_v2_1.HelperCardPriority.INVALID_PRIORITY,
        progressContext: undefined,
        rightLabel: '',
    };
}
exports.HelperCardContext = {
    fromJSON(object) {
        const message = {
            displayLocation: globalThis.Array.isArray(object?.displayLocation)
                ? object.displayLocation.map((e) => (0, lifecycle_enum_v2_1.displayLocationFromJSON)(e))
                : [],
            dismissible: isSet(object.dismissible) ? globalThis.Boolean(object.dismissible) : false,
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
            priority: isSet(object.priority)
                ? (0, lifecycle_enum_v2_1.helperCardPriorityFromJSON)(object.priority)
                : lifecycle_enum_v2_1.HelperCardPriority.INVALID_PRIORITY,
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.ageInDays)) {
            message.ageInDays = globalThis.Number(object.ageInDays);
        }
        if (isSet(object.progressContext)) {
            message.progressContext = exports.ProgressContext.fromJSON(object.progressContext);
        }
        if (isSet(object.rightLabel)) {
            message.rightLabel = globalThis.String(object.rightLabel);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.displayLocation?.length) {
            obj.displayLocation = message.displayLocation.map((e) => (0, lifecycle_enum_v2_1.displayLocationToJSON)(e));
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.dismissible !== false) {
            obj.dismissible = message.dismissible;
        }
        if (message.ageInDays !== undefined && message.ageInDays !== 0) {
            obj.ageInDays = Math.round(message.ageInDays);
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        if (message.priority !== lifecycle_enum_v2_1.HelperCardPriority.INVALID_PRIORITY) {
            obj.priority = (0, lifecycle_enum_v2_1.helperCardPriorityToJSON)(message.priority);
        }
        if (message.progressContext !== undefined) {
            obj.progressContext = exports.ProgressContext.toJSON(message.progressContext);
        }
        if (message.rightLabel !== undefined && message.rightLabel !== '') {
            obj.rightLabel = message.rightLabel;
        }
        return obj;
    },
    create(base) {
        return exports.HelperCardContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHelperCardContext();
        message.displayLocation = object.displayLocation?.map((e) => e) || [];
        message.accountId = object.accountId ?? '';
        message.dismissible = object.dismissible ?? false;
        message.ageInDays = object.ageInDays ?? 0;
        message.enabled = object.enabled ?? false;
        message.priority = object.priority ?? lifecycle_enum_v2_1.HelperCardPriority.INVALID_PRIORITY;
        message.progressContext =
            (object.progressContext !== undefined && object.progressContext !== null)
                ? exports.ProgressContext.fromPartial(object.progressContext)
                : undefined;
        message.rightLabel = object.rightLabel ?? '';
        return message;
    },
};
function createBaseHalfModalContext() {
    return { primaryButtonText: '', secondaryButtonText: '' };
}
exports.HalfModalContext = {
    fromJSON(object) {
        const message = {
            primaryButtonText: isSet(object.primaryButtonText)
                ? globalThis.String(object.primaryButtonText)
                : '',
        };
        if (isSet(object.secondaryButtonText)) {
            message.secondaryButtonText = globalThis.String(object.secondaryButtonText);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryButtonText !== '') {
            obj.primaryButtonText = message.primaryButtonText;
        }
        if (message.secondaryButtonText !== undefined && message.secondaryButtonText !== '') {
            obj.secondaryButtonText = message.secondaryButtonText;
        }
        return obj;
    },
    create(base) {
        return exports.HalfModalContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHalfModalContext();
        message.primaryButtonText = object.primaryButtonText ?? '';
        message.secondaryButtonText = object.secondaryButtonText ?? '';
        return message;
    },
};
function createBaseFullModalContext() {
    return {
        primaryButtonText: '',
        secondaryButtonText: '',
        progressContext: undefined,
        confetti: false,
    };
}
exports.FullModalContext = {
    fromJSON(object) {
        const message = {
            primaryButtonText: isSet(object.primaryButtonText)
                ? globalThis.String(object.primaryButtonText)
                : '',
            confetti: isSet(object.confetti) ? globalThis.Boolean(object.confetti) : false,
        };
        if (isSet(object.secondaryButtonText)) {
            message.secondaryButtonText = globalThis.String(object.secondaryButtonText);
        }
        if (isSet(object.progressContext)) {
            message.progressContext = exports.ProgressContext.fromJSON(object.progressContext);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryButtonText !== '') {
            obj.primaryButtonText = message.primaryButtonText;
        }
        if (message.secondaryButtonText !== undefined && message.secondaryButtonText !== '') {
            obj.secondaryButtonText = message.secondaryButtonText;
        }
        if (message.progressContext !== undefined) {
            obj.progressContext = exports.ProgressContext.toJSON(message.progressContext);
        }
        if (message.confetti !== false) {
            obj.confetti = message.confetti;
        }
        return obj;
    },
    create(base) {
        return exports.FullModalContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFullModalContext();
        message.primaryButtonText = object.primaryButtonText ?? '';
        message.secondaryButtonText = object.secondaryButtonText ?? '';
        message.progressContext =
            (object.progressContext !== undefined && object.progressContext !== null)
                ? exports.ProgressContext.fromPartial(object.progressContext)
                : undefined;
        message.confetti = object.confetti ?? false;
        return message;
    },
};
function createBaseNavigationContext() {
    return {};
}
exports.NavigationContext = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.NavigationContext.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseNavigationContext();
        return message;
    },
};
function createBaseProgressContext() {
    return { progress: 0, leftLabel: '', rightLabel: '', leftImageUrl: '', rightImageUrl: '' };
}
exports.ProgressContext = {
    fromJSON(object) {
        const message = {
            progress: isSet(object.progress) ? globalThis.Number(object.progress) : 0,
        };
        if (isSet(object.leftLabel)) {
            message.leftLabel = globalThis.String(object.leftLabel);
        }
        if (isSet(object.rightLabel)) {
            message.rightLabel = globalThis.String(object.rightLabel);
        }
        if (isSet(object.leftImageUrl)) {
            message.leftImageUrl = globalThis.String(object.leftImageUrl);
        }
        if (isSet(object.rightImageUrl)) {
            message.rightImageUrl = globalThis.String(object.rightImageUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.progress !== 0) {
            obj.progress = Math.round(message.progress);
        }
        if (message.leftLabel !== undefined && message.leftLabel !== '') {
            obj.leftLabel = message.leftLabel;
        }
        if (message.rightLabel !== undefined && message.rightLabel !== '') {
            obj.rightLabel = message.rightLabel;
        }
        if (message.leftImageUrl !== undefined && message.leftImageUrl !== '') {
            obj.leftImageUrl = message.leftImageUrl;
        }
        if (message.rightImageUrl !== undefined && message.rightImageUrl !== '') {
            obj.rightImageUrl = message.rightImageUrl;
        }
        return obj;
    },
    create(base) {
        return exports.ProgressContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProgressContext();
        message.progress = object.progress ?? 0;
        message.leftLabel = object.leftLabel ?? '';
        message.rightLabel = object.rightLabel ?? '';
        message.leftImageUrl = object.leftImageUrl ?? '';
        message.rightImageUrl = object.rightImageUrl ?? '';
        return message;
    },
};
function createBaseProgressionMetadata() {
    return { title: '', headerImageUrl: '' };
}
exports.ProgressionMetadata = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            headerImageUrl: isSet(object.headerImageUrl) ? globalThis.String(object.headerImageUrl) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.headerImageUrl !== '') {
            obj.headerImageUrl = message.headerImageUrl;
        }
        return obj;
    },
    create(base) {
        return exports.ProgressionMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProgressionMetadata();
        message.title = object.title ?? '';
        message.headerImageUrl = object.headerImageUrl ?? '';
        return message;
    },
};
function createBaseGetProgressRequest() {
    return { progressType: lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE };
}
exports.GetProgressRequest = {
    fromJSON(object) {
        const message = {
            progressType: isSet(object.progressType)
                ? (0, lifecycle_enum_v2_1.progressTypeFromJSON)(object.progressType)
                : lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.progressType !== lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE) {
            obj.progressType = (0, lifecycle_enum_v2_1.progressTypeToJSON)(message.progressType);
        }
        return obj;
    },
    create(base) {
        return exports.GetProgressRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProgressRequest();
        message.progressType = object.progressType ?? lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE;
        return message;
    },
};
function createBaseGetProgressResponse() {
    return {
        reward: undefined,
        progressContext: exports.ProgressContext.fromPartial({}),
        ctas: [],
        progressType: lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE,
        progressionMetadata: exports.ProgressionMetadata.fromPartial({}),
    };
}
exports.GetProgressResponse = {
    fromJSON(object) {
        const message = {
            progressContext: isSet(object.progressContext)
                ? exports.ProgressContext.fromJSON(object.progressContext)
                : exports.ProgressContext.fromPartial({}),
            ctas: globalThis.Array.isArray(object?.ctas)
                ? object.ctas.map((e) => exports.Cta.fromJSON(e))
                : [],
            progressType: isSet(object.progressType)
                ? (0, lifecycle_enum_v2_1.progressTypeFromJSON)(object.progressType)
                : lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE,
            progressionMetadata: isSet(object.progressionMetadata)
                ? exports.ProgressionMetadata.fromJSON(object.progressionMetadata)
                : exports.ProgressionMetadata.fromPartial({}),
        };
        if (isSet(object.reward)) {
            message.reward = amount_1.Amount.fromJSON(object.reward);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reward !== undefined) {
            obj.reward = amount_1.Amount.toJSON(message.reward);
        }
        if (message.progressContext !== undefined) {
            obj.progressContext = exports.ProgressContext.toJSON(message.progressContext);
        }
        if (message.ctas?.length) {
            obj.ctas = message.ctas.map((e) => exports.Cta.toJSON(e));
        }
        if (message.progressType !== lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE) {
            obj.progressType = (0, lifecycle_enum_v2_1.progressTypeToJSON)(message.progressType);
        }
        if (message.progressionMetadata !== undefined) {
            obj.progressionMetadata = exports.ProgressionMetadata.toJSON(message.progressionMetadata);
        }
        return obj;
    },
    create(base) {
        return exports.GetProgressResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProgressResponse();
        message.reward = (object.reward !== undefined && object.reward !== null)
            ? amount_1.Amount.fromPartial(object.reward)
            : undefined;
        message.progressContext =
            (object.progressContext !== undefined && object.progressContext !== null)
                ? exports.ProgressContext.fromPartial(object.progressContext)
                : exports.ProgressContext.fromPartial({});
        message.ctas = object.ctas?.map((e) => exports.Cta.fromPartial(e)) || [];
        message.progressType = object.progressType ?? lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE;
        message.progressionMetadata =
            (object.progressionMetadata !== undefined && object.progressionMetadata !== null)
                ? exports.ProgressionMetadata.fromPartial(object.progressionMetadata)
                : exports.ProgressionMetadata.fromPartial({});
        return message;
    },
};
function createBaseProgression() {
    return {
        progressContext: exports.ProgressContext.fromPartial({}),
        progressionMetadata: exports.ProgressionMetadata.fromPartial({}),
        progressType: lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE,
        ctas: [],
    };
}
exports.Progression = {
    fromJSON(object) {
        const message = {
            progressContext: isSet(object.progressContext)
                ? exports.ProgressContext.fromJSON(object.progressContext)
                : exports.ProgressContext.fromPartial({}),
            progressionMetadata: isSet(object.progressionMetadata)
                ? exports.ProgressionMetadata.fromJSON(object.progressionMetadata)
                : exports.ProgressionMetadata.fromPartial({}),
            progressType: isSet(object.progressType)
                ? (0, lifecycle_enum_v2_1.progressTypeFromJSON)(object.progressType)
                : lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE,
            ctas: globalThis.Array.isArray(object?.ctas)
                ? object.ctas.map((e) => exports.Cta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.progressContext !== undefined) {
            obj.progressContext = exports.ProgressContext.toJSON(message.progressContext);
        }
        if (message.progressionMetadata !== undefined) {
            obj.progressionMetadata = exports.ProgressionMetadata.toJSON(message.progressionMetadata);
        }
        if (message.progressType !== lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE) {
            obj.progressType = (0, lifecycle_enum_v2_1.progressTypeToJSON)(message.progressType);
        }
        if (message.ctas?.length) {
            obj.ctas = message.ctas.map((e) => exports.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Progression.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProgression();
        message.progressContext =
            (object.progressContext !== undefined && object.progressContext !== null)
                ? exports.ProgressContext.fromPartial(object.progressContext)
                : exports.ProgressContext.fromPartial({});
        message.progressionMetadata =
            (object.progressionMetadata !== undefined && object.progressionMetadata !== null)
                ? exports.ProgressionMetadata.fromPartial(object.progressionMetadata)
                : exports.ProgressionMetadata.fromPartial({});
        message.progressType = object.progressType ?? lifecycle_enum_v2_1.ProgressType.INVALID_PROGRESS_TYPE;
        message.ctas = object.ctas?.map((e) => exports.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetAccountProgressionsRequest() {
    return {};
}
exports.GetAccountProgressionsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAccountProgressionsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetAccountProgressionsRequest();
        return message;
    },
};
function createBaseGetAccountProgressionsResponse() {
    return { progressions: [] };
}
exports.GetAccountProgressionsResponse = {
    fromJSON(object) {
        const message = {
            progressions: globalThis.Array.isArray(object?.progressions)
                ? object.progressions.map((e) => exports.Progression.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.progressions?.length) {
            obj.progressions = message.progressions.map((e) => exports.Progression.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountProgressionsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountProgressionsResponse();
        message.progressions = object.progressions?.map((e) => exports.Progression.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetCtasRequest() {
    return { targetUserId: undefined };
}
exports.GetCtasRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.targetUserId)) {
            message.targetUserId = globalThis.String(object.targetUserId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.targetUserId !== undefined) {
            obj.targetUserId = message.targetUserId;
        }
        return obj;
    },
    create(base) {
        return exports.GetCtasRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCtasRequest();
        message.targetUserId = object.targetUserId ?? undefined;
        return message;
    },
};
function createBaseGetCtasResponse() {
    return { ctas: [] };
}
exports.GetCtasResponse = {
    fromJSON(object) {
        const message = {
            ctas: globalThis.Array.isArray(object?.ctas)
                ? object.ctas.map((e) => exports.Cta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctas?.length) {
            obj.ctas = message.ctas.map((e) => exports.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCtasResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCtasResponse();
        message.ctas = object.ctas?.map((e) => exports.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateCtaStatusRequest() {
    return { ctaId: undefined, action: undefined, status: lifecycle_enum_v2_1.Status.INVALID_STATUS };
}
exports.UpdateCtaStatusRequest = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status) ? (0, lifecycle_enum_v2_1.statusFromJSON)(object.status) : lifecycle_enum_v2_1.Status.INVALID_STATUS,
        };
        if (isSet(object.ctaId)) {
            message.ctaId = globalThis.String(object.ctaId);
        }
        if (isSet(object.action)) {
            message.action = globalThis.String(object.action);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctaId !== undefined) {
            obj.ctaId = message.ctaId;
        }
        if (message.action !== undefined) {
            obj.action = message.action;
        }
        if (message.status !== lifecycle_enum_v2_1.Status.INVALID_STATUS) {
            obj.status = (0, lifecycle_enum_v2_1.statusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCtaStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCtaStatusRequest();
        message.ctaId = object.ctaId ?? undefined;
        message.action = object.action ?? undefined;
        message.status = object.status ?? lifecycle_enum_v2_1.Status.INVALID_STATUS;
        return message;
    },
};
function createBaseUpdateCtaStatusResponse() {
    return { ctas: [] };
}
exports.UpdateCtaStatusResponse = {
    fromJSON(object) {
        const message = {
            ctas: globalThis.Array.isArray(object?.ctas)
                ? object.ctas.map((e) => exports.Cta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctas?.length) {
            obj.ctas = message.ctas.map((e) => exports.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCtaStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCtaStatusResponse();
        message.ctas = object.ctas?.map((e) => exports.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateOnboardingCustomerTypeRequest() {
    return { customerType: lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE };
}
exports.UpdateOnboardingCustomerTypeRequest = {
    fromJSON(object) {
        const message = {
            customerType: isSet(object.customerType)
                ? (0, lifecycle_customer_1.customerTypeFromJSON)(object.customerType)
                : lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.customerType !== lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE) {
            obj.customerType = (0, lifecycle_customer_1.customerTypeToJSON)(message.customerType);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateOnboardingCustomerTypeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateOnboardingCustomerTypeRequest();
        message.customerType = object.customerType ?? lifecycle_customer_1.CustomerType.INVALID_CUSTOMER_TYPE;
        return message;
    },
};
function createBaseUpdateOnboardingCustomerTypeResponse() {
    return { ctas: [] };
}
exports.UpdateOnboardingCustomerTypeResponse = {
    fromJSON(object) {
        const message = {
            ctas: globalThis.Array.isArray(object?.ctas)
                ? object.ctas.map((e) => exports.Cta.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctas?.length) {
            obj.ctas = message.ctas.map((e) => exports.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UpdateOnboardingCustomerTypeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateOnboardingCustomerTypeResponse();
        message.ctas = object.ctas?.map((e) => exports.Cta.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAckCtaV2Request() {
    return { ctaId: '' };
}
exports.AckCtaV2Request = {
    fromJSON(object) {
        const message = {
            ctaId: isSet(object.ctaId) ? globalThis.String(object.ctaId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ctaId !== '') {
            obj.ctaId = message.ctaId;
        }
        return obj;
    },
    create(base) {
        return exports.AckCtaV2Request.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAckCtaV2Request();
        message.ctaId = object.ctaId ?? '';
        return message;
    },
};
function createBaseAckCtaV2Response() {
    return {};
}
exports.AckCtaV2Response = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AckCtaV2Response.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAckCtaV2Response();
        return message;
    },
};
function createBaseRecordMilestoneReachedRequest() {
    return { type: lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE, referenceId: '' };
}
exports.RecordMilestoneReachedRequest = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, lifecycle_milestone_1.milestoneTypeFromJSON)(object.type)
                : lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE,
        };
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE) {
            obj.type = (0, lifecycle_milestone_1.milestoneTypeToJSON)(message.type);
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        return obj;
    },
    create(base) {
        return exports.RecordMilestoneReachedRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordMilestoneReachedRequest();
        message.type = object.type ?? lifecycle_milestone_1.MilestoneType.INVALID_MILESTONE_TYPE;
        message.referenceId = object.referenceId ?? '';
        return message;
    },
};
function createBaseRecordMilestoneReachedResponse() {
    return { cta: [] };
}
exports.RecordMilestoneReachedResponse = {
    fromJSON(object) {
        const message = {
            cta: globalThis.Array.isArray(object?.cta) ? object.cta.map((e) => exports.Cta.fromJSON(e)) : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cta?.length) {
            obj.cta = message.cta.map((e) => exports.Cta.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RecordMilestoneReachedResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordMilestoneReachedResponse();
        message.cta = object.cta?.map((e) => exports.Cta.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Lifecycle Service V2 API.
 *
 * Manages CTAs based on user state in their account lifecycle.
 */
class LifecycleServiceV2Client {
    rpc;
    name = 'com.step.lifecycle.v2.proto.LifecycleServiceV2';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/lifecycle';
    methods = [{
            name: 'GetCtas',
            requestType: exports.GetCtasRequest,
            responseType: exports.GetCtasResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetProgress',
            requestType: exports.GetProgressRequest,
            responseType: exports.GetProgressResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetAccountProgressions',
            requestType: exports.GetAccountProgressionsRequest,
            responseType: exports.GetAccountProgressionsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateCtaStatus',
            requestType: exports.UpdateCtaStatusRequest,
            responseType: exports.UpdateCtaStatusResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateOnboardingCustomerType',
            requestType: exports.UpdateOnboardingCustomerTypeRequest,
            responseType: exports.UpdateOnboardingCustomerTypeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'AckCtaV2',
            requestType: exports.AckCtaV2Request,
            responseType: exports.AckCtaV2Response,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RecordMilestoneReached',
            requestType: exports.RecordMilestoneReachedRequest,
            responseType: exports.RecordMilestoneReachedResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get user CTAs
     */
    getCtas(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a user's progress for a flow. Also creates a milestone if the progress
     * reaches 100%.
     */
    getProgress(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a user's account progressions. It will include basic progression
     * and interest-based progression.
     */
    getAccountProgressions(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update a user's CTA status
     */
    updateCtaStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update the customer type of the onboarding flow
     */
    updateOnboardingCustomerType(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Acknowledges CTA
     */
    ackCtaV2(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Record that a user reached a milestone.
     */
    recordMilestoneReached(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.LifecycleServiceV2Client = LifecycleServiceV2Client;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=lifecycle-service-v2.js.map